import { type IUserProfile } from '@inpart-io/devtools-iap';
import { type GetterTree } from 'vuex';

import { type IUserProfileState } from './types';

export const GET_FROM_USER = 'getFromUser';

export const getters: GetterTree<IUserProfileState, unknown> = {
    [GET_FROM_USER]: (_state: IUserProfileState) => {
        return (dobjId: number): IUserProfile | undefined => {
            const userProfileId = _state.byUser.get(dobjId);
            return userProfileId !== null && userProfileId !== undefined ? _state.dataObjectList.get(userProfileId) : undefined;
        };
    }
};
